import { TabSwitcher } from "./TabSwitcher";
import OverviewTab from "@/pages/applications/tabs/OverviewTab";
import AuthorizationTab from "@/pages/applications/tabs/AuthorizationTab";
import IdentificationTab from "@/pages/applications/tabs/IdentificationTab";
import CreditTab from "@/pages/applications/tabs/CreditTab";
import CriminalTab from "@/pages/applications/tabs/CriminalTab";
import RentalHistoryTab from "@/pages/applications/tabs/RentalHistoryTab";
import ProofOfIncomeTab from "@/pages/applications/tabs/ProofOfIncomeTab";

const TABS = [
  {
    label: "Overview",
    key: "overview",
    component: OverviewTab,
  },
  {
    label: "Authorization",
    key: "auth",
    component: AuthorizationTab,
  },
  {
    label: "Identification",
    key: "identification",
    component: IdentificationTab,
  },
  {
    label: "Credit",
    key: "credit",
    component: CreditTab,
  },
  {
    label: "Criminal",
    key: "criminal",
    component: CriminalTab,
  },
  {
    label: "Rental History",
    key: "rental",
    component: RentalHistoryTab,
  },
  {
    label: "Proof of Income",
    key: "poi",
    component: ProofOfIncomeTab,
  },
];

const TabLabel = ({ label = "", completed = "false" }) => {
  return (
    <span className="tab-label">
      {label}
      {completed && <i className="ms-2 bi bi-check-circle-fill text-success" />}
    </span>
  );
};

const ApplicationTabContent = () => {
  return <TabSwitcher tabs={TABS} />;
};

ApplicationTabContent.propTypes = {};

export default ApplicationTabContent;
